<template>

  <div class="container">
    <h1>SSE Test</h1>

    <div v-for="(update, index) in updateList" :key="index">
      {{update}}
    </div>

  </div>

</template>


<script>

export default {
  name: "AdminSSE",
  data() {
    return {
      eventSource: null,
      updateList: [],
    }
  },
  mounted() {
    this.startEventStream();
  },
  beforeUnmount() {
    this.eventSource?.close();
  },
  methods: {
    async startEventStream() {
      // Initialize the EventSource, listening for server updates
      this.eventSource = new EventSource(`${this.$apiPath}/api/sse/test`);
      console.log(`eventSource`, this.eventSource);

      this.eventSource.addEventListener('connection', (/*event*/) => {
        console.log('--connection event--');
      });

      this.eventSource.addEventListener('userUpdate', event => {
        console.log(JSON.parse(event.data));

        this.updateList.push(JSON.parse(event.data).email);
      });

      // Log connection error
      this.eventSource.onerror = function(event) {
        console.log('Error occurred:', event);
      };
    },
  }
}
</script>


<style scoped>

</style>